import type { TFunction } from 'i18next'
import type { AllValuesCopy } from './AllValues'

export function getLeadingValuePerSqmLabels(tCommon: TFunction): AllValuesCopy['leadingValuePerSqm'] {
    return {
        valuePerSquareMeter: tCommon('valuePerSquareMeter'),
        valuePerSquareMeterGfa: tCommon('valuePerSquareMeterGfa'),
        valuePerSquareMeterLand: tCommon('valuePerSquareMeterLand'),
        rentableArea: tCommon('rentableArea'),
        grossFloorArea: tCommon('grossFloorArea'),
        landArea: tCommon('landArea'),
    }
}

export function getAllValuesCopy(tCommon: TFunction, tAllValues: TFunction, tAllValuesPage: TFunction): AllValuesCopy {
    return {
        title: tCommon('valuationKeyFigures'),
        sections: {
            marketValueResults: tCommon('marketValueResults'),
            mortgageLendingValueResults: tAllValuesPage('sections.mortgageLendingValueResults'),
            incomeMetrics: tCommon('incomeMetrics'),
            yields: tAllValuesPage('sections.yields'),
            relevantArea: tAllValuesPage('sections.relevantArea'),
            residualUsefulLife: tCommon('residualUsefulLife'),
        },
        rows: {
            marketValue: tCommon('marketValue'),
            landValue: tCommon('landValue'),
            incomeMethod: tCommon('valuationMethods.income'),
            investmentMethod: tCommon('valuationMethods.investment_method'),
            costMethod: tCommon('valuationMethods.cost'),
            comparisonMethod: tCommon('valuationMethods.comparison'),
            discountedCashflow: tAllValues('rows.discountedCashflowShort'),
            transactionCosts: tAllValues('rows.transactionCosts'),
            marketValueIncludingTransactionCosts: tAllValues('rows.marketValueIncludingTransactionCosts'),
            mortgageLendingValue: tAllValues('rows.mortgageLendingValue'),
            grossRentalIncome: tAllValues('rows.grossRentalIncome'),
            contractRent: tCommon('contractRent'),
            marketRent: tCommon('marketRent'),
            managementCosts: tAllValues('rows.managementCosts'),
            netRentalIncome: tAllValues('rows.netRentalIncome'),
            wault: tCommon('wault'),
            grossYieldMultiplier: tAllValues('rows.grossYieldMultiplier'),
            netYieldMultiplier: tAllValues('rows.netYieldMultiplier'),
            grossYield: tAllValues('rows.grossYieldVerbose'),
            grossInitialYield: tCommon('grossInitialYield'),
            discountRate: tCommon('discountRate'),
            rentableArea: tCommon('rentableArea'),
            grossFloorArea: tCommon('grossFloorArea'),
            landArea: tCommon('landArea'),
        },
        values: {
            waultUnlimited: tAllValues('values.waultUnlimited'),
        },
        units: {
            year: tAllValuesPage('year'),
            years: tAllValuesPage('years'),
        },
        leadingValuePerSqm: getLeadingValuePerSqmLabels(tCommon),
    }
}
